module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/h1-title@2x-ea6ae5299c49612842c8fc45ba9bbc8d.png";